import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import InputText from "./../../components/input/InputText";
import TextAmount from "./../../components/text/TextAmount";
import InputDropDownList from "./../../components/input/InputDropDownList";
import EditForm from "../../components/form/EditForm";
import RowButtons from "../../components/button/RowButtons";
import RowDeleteButton from "./../../components/button/RowDeleteButton";
import ListTable from "./../../components/form/ListTable";
import { useErrorContext } from "../../components/messages/ErrorBox";
import EditFormFieldTable from "components/form/EditFormFieldTable";
import {
  apiGetCall,
  apiPostCall,
  isResultOk,
} from "./../../components/special/apiCall";
import { usePageLoadingContext } from "./../../components/messages/PageLoading";
import { useLocale } from "./../../components/special/LanguageProvider";
import InputCheckBox from "components/input/InputCheckBox";

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const LabelsEdit = () => {
  //Some helpers.
  const params = new URLSearchParams(useLocation().search);
  const navigator = useHistory();
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

  const labelColorOptions = [
    { itemID: "C40F11", name: "Rauður" },
    { itemID: "014ABE", name: "Blár" },
    { itemID: "0A7A00", name: "Grænn" },
    { itemID: "E66D00", name: "Appelsínugulur" },
    { itemID: "333333", name: "Grár" },
    { itemID: "691A12", name: "Brúnn" },
    { itemID: "097C8E", name: "Sæblár" },
    { itemID: "673AB7", name: "Fjólublár" },
    { itemID: "8C0086", name: "Purpurarauður" },
    { itemID: "C7007B", name: "Bleikur" },
  ];

  //Init blank formdata record.
  const [formData, setFormData] = useState({
    isNew: true,
    selectedLabelType: null,
    claimCount: 0,
  });

  const [workingData, setWorkingData] = useState({
    labelID: 0,
    name: "",
    colorCode: null,
    isEnabled: true,
    labelTypeID: null,
  });

  const [lookupData, setLookupData] = useState({
    labelTypesList: [],
  });

  const loadLookupData = async () => {
    //Load all the data at the same time.
    let [labelTypesList] = await Promise.all([
      apiGetCall(BASE_URL + "/admin/list/label/types"),
    ]);
    //Check we need to display any critical errors.
    setCheckErrorItems([labelTypesList]);

    //Translate the data into what we want to use.
    setLookupData({
      labelTypesList: labelTypesList,
    });
  };

  const loadFormData = async () => {
    setIsPageLoading(true);
    let newFormData = { ...formData };
    //console.log("load");
    //Read the query parameters, if we don´t have any then go back to transaction keys.
    let labelID = params.get("labelid");
    let isNew = params.get("newkey");
    // console.log(labelID, isNew);
    if (labelID == null || labelID <= 0) {
      if (isNew == null) {
        navigator.push("/admin/labels");
      } else {
        newFormData.isNew = true;
      }
    }

    //Check if we have new item or old item.
    let label = null;
    if (labelID > 0) {
      newFormData.isNew = false;
      newFormData.labelID = labelID;
      label = await apiGetCall(BASE_URL + "/admin/label/" + labelID);
      if (isResultOk(label)) {
        // console.log("workingdata", label);
        setWorkingData(label);
      }
      //console.log("labelID", label);
      if (label.labelTypeID == 4) {
        let currClaimCount = 0;
        currClaimCount = await apiGetCall(
          BASE_URL + "/admin/label/" + labelID + "/claimcount"
        );
        //console.log("currClaimCount", currClaimCount)
        if (isResultOk(currClaimCount)) {
          newFormData.claimCount = currClaimCount;
        }
      }
    }

    //Lookup data.
    await loadLookupData();

    setFormData(newFormData);

    setIsPageLoading(false);
  };

  const onDeleteClick = async () => {
    setIsPageLoading(true);
    if (formData.claimCount > 0) {
      let remData = { labelID: workingData.labelID };
      let data = await apiPostCall(
        BASE_URL + "/admin/label/remove/claims",
        remData
      );
      if (isResultOk(data)) {
        let tempFormData = { ...formData };
        tempFormData.claimCount = 0;
        setFormData(tempFormData);
      }
    }
    setIsPageLoading(false);
  };

  useEffect(() => {
    loadFormData();
  }, []);

  const onSaveClick = async () => {
    setIsPageLoading(true);
    let requestResult = null;
    //   if (1 != 1) {
    if (!formData.isNew) {
      requestResult = await apiPostCall(
        BASE_URL + "/admin/label/update",
        workingData
      );
    } else {
      requestResult = await apiPostCall(
        BASE_URL + "/admin/label/create",
        workingData
      );
    }
    //   }
    if (isResultOk(requestResult, setCheckErrorItems)) {
      goBack();
    }
    setIsPageLoading(false);
  };

  const goBack = () => {
    navigator.push("/admin/labels");
  };

  const validateInput = () => {
    let messages = [];
    if (workingData.name === "") {
      messages.push("Vantar heiti merkingar");
    }
    if (workingData.labelTypeID == null || workingData.labelTypeID == 0) {
      messages.push("Vantar að velja tegund merkingar");
    }
    return messages; //return list of messsages, if > 0 then onSaveClick is not activated.
  };

  //console.log("formData", formData);

  return (
    <EditForm
      newTitle="Ný merking"
      changeTitle="Breyta merkingu"
      isNew={formData.isNew}
      onSubmitClick={onSaveClick}
      onValidate={validateInput}
    >
      <EditFormFieldTable
        fields={[
          {
            title: "Heiti merkingar",
            edit: () => (
              <InputText
                name="merking"
                value={workingData.name}
                onChange={(value) =>
                  setWorkingData({ ...workingData, name: value })
                }
              />
            ),
          },
          {
            title: "Tegund merkingar",
            edit: () => (
              <InputDropDownList
                name="tegundMerkingar"
                list={lookupData.labelTypesList}
                keyField="itemID"
                displayField={(item) => {
                  return item.name;
                }}
                defaultValue={workingData.labelTypeID}
                onChange={(value) =>
                  setWorkingData({ ...workingData, labelTypeID: value })
                }
                nullable={true}
                nullableItem={{ itemID: null, name: "" }}
              />
            ),
          },
          {
            title: "Litur merkingar",
            edit: () => (
              <InputDropDownList
                name="liturMerkingar"
                list={labelColorOptions}
                keyField="itemID"
                displayField={(item) => item.name}
                defaultValue={workingData.colorCode}
                onChange={(value) =>
                  setWorkingData({ ...workingData, colorCode: value })
                }
                nullable={true}
                nullableItem={{ itemID: null, name: "" }}
              />
            ),
          },
          {
            title: "Merking Virk",
            edit: () => (
              <InputCheckBox
                value={workingData.isEnabled}
                onChange={(value) =>
                  setWorkingData({ ...workingData, isEnabled: value })
                }
              />
            ),
          },
        ]}
      />
      <div style={{ display: workingData.labelTypeID == 4 ? "block" : "none" }}>
        <div>
          <EditFormFieldTable
            fields={[
              {
                title: "Fjöldi krafna í vinnuhóp",
                edit: () => (
                  <table className="table claim coun">
                    <colgroup>
                      <col />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td>
                          <TextAmount value={formData.claimCount} />
                        </td>
                        <td>
                          <RowButtons>
                            <RowDeleteButton onClick={() => onDeleteClick()} />
                          </RowButtons>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ),
              },
            ]}
          />
        </div>
      </div>
    </EditForm>
  );
};
